import { render, staticRenderFns } from "./SucceedModal.vue?vue&type=template&id=95299498"
import script from "./SucceedModal.vue?vue&type=script&lang=js"
export * from "./SucceedModal.vue?vue&type=script&lang=js"
import style0 from "./SucceedModal.vue?vue&type=style&index=0&id=95299498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports